// Module Import
//---------------------------------
import 'slick-carousel/slick/slick.scss'
import '../../../assets/css/slick-theme.scss'

import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import ImageCut from '../../../assets/images/graphic_imageCut.svg'
import ProductCard from '../ProductCard/ProductCard'
import nodeApi from '../../../utils/api/nodeApi/nodeApi'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const GalleryCarouselWrapper = styled.div`
  border-radius: 4px;
  position: relative;
  height: 100%;

  .slick-slider {
    display: flex;
    flex-direction: column;
    height: 100%;

    .slick-track {
      height: 100%;

      .slick-slide > div {
        height: 100%;
      }
    }
  }
`

const Slide = styled.div`
  padding: 24px;
  height: 100%;
`

// Component Export
//---------------------------------
export default function ProductCarousel({ carouselImages, nonFooter }) {
  const [productArray, setProductArray] = useState(carouselImages)
  const [isLoading, setIsLoading] = useState(false)

  const productIdArray = carouselImages?.map(({ shopifyId }) => shopifyId) || []

  const carouselSettings = {
    dots: true,
    infinite: carouselImages.length > 3,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplaySpeed: 4000,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }

  useEffect(() => {
    if (nonFooter) return

    const getActualProductQuantity = async () => {
      setIsLoading(true)

      const productInfo = await nodeApi.getActualProductQuantity(productIdArray)

      if (productInfo?.length > 0) {
        setProductArray(
          carouselImages.map((product) => {
            const actualInventory = productInfo.find(
              ({ id }) => id === product.shopifyId
            )?.totalInventory

            return {
              ...product,
              totalInventory: actualInventory ?? product.totalInventory,
            }
          })
        )
      }

      setIsLoading(false)
    }

    getActualProductQuantity()
  }, [])

  return (
    <GalleryCarouselWrapper>
      <Slider {...carouselSettings}>
        {productArray.map((target) => (
          <Slide key={target.handle}>
            <ProductCard
              carousel
              productTitle={target.title}
              key={target.handle}
              productDescription={target.metafield === null ? null : target.metafield.value}
              productPrice={target.priceRangeV2 ? target.priceRangeV2.minVariantPrice.amount : null}
              isRental={target.productType.toLowerCase().includes('rental')}
              hidePrice={target?.tags?.includes('enquire only') || false}
              isNotify={target.tags && target.tags.some((tag) => tag === 'notify')}
              imgSrc={target.featuredImage?.gatsbyImageData || ''}
              altTag={target.featuredImage?.description || ''}
              productLink={`/products/${target.handle}`}
              stockLevel={
                target.productType.toLowerCase().includes('rental') ? null : target.totalInventory
              }
              isLoading={isLoading}
              nonFooter={nonFooter}
            />
          </Slide>
        ))}
      </Slider>
    </GalleryCarouselWrapper>
  )
}
